import { resolveNoContent, resolveWithBody } from "./Utils/utils";
import { AwardPointsForWinArguments } from "../EventRankings/CalculationRules/types";
import { usePromisedRequest as promiseRequest } from "../Common/request";

export type RuleDefinition = {
    rule: string;
    arguments: AwardPointsForWinArguments; // Union type for different rules arguments.
    selectedCategories: number[];
};

export type EventRankingCompetitor = {
    competitorId: number;
    firstName: string;
    lastName: string;
    score: number;
    wonMatches: number;
    lostMatches: number;
    place: number;
};

export type GeneratedRankingResponse = {
    competitors: EventRankingCompetitor[];
};

export type EventRankingSaveRequest = {
    eventId: number;
    name: string;
    rules: {
        ruleDefinitions: RuleDefinition[];
    };
};

export type SavedEventRanking = {
    id: number;
    name: string;
    created: string;
} & GeneratedRankingResponse;

export default {
    generateRankingForRules(eventId: number, ruleDefinitions: RuleDefinition[]): Promise<GeneratedRankingResponse> {
        return promiseRequest<GeneratedRankingResponse>({
            url: `/api/admin/events/${eventId}/actions/generate-ranking`,
            json: {
                ruleDefinitions,
            },
            method: "post",
        }).then(resolveWithBody());
    },
    saveRanking(request: EventRankingSaveRequest): Promise<void> {
        return promiseRequest({
            url: `/api/admin/events/${request.eventId}/actions/save-ranking`,
            method: "post",
            json: request,
        }).then(resolveNoContent());
    },
    getListing(eventId: number): Promise<SavedEventRanking[]> {
        return promiseRequest<SavedEventRanking[]>({
            url: `/api/admin/events/${eventId}/rankings`,
            json: true,
            method: "get",
        }).then(resolveWithBody());
    },
    deleteSavedRanking(eventId: number, rankingId: number): Promise<void> {
        return promiseRequest({
            url: `/api/admin/events/${eventId}/rankings/${rankingId}`,
            method: "delete",
        }).then(resolveNoContent());
    },
};
